import deleteFormulaRequest from "./requests/delete-formula-request";
import calculateRequest from "./requests/calculate-request";
import setFormulaRequest from "./requests/set-formula-request";
import getStaffRequest from "./requests/get-staff-request";
import getFormulasRequest from "./requests/get-formulas-request";

const salaryRepository = {
    deleteFormula: deleteFormulaRequest,
    calculate: calculateRequest,
    setFormula: setFormulaRequest,
    getStaff: getStaffRequest,
    getFormulas: getFormulasRequest,
};

export default salaryRepository;